// client/src/api/TrialApi.ts
import { axiosInstance } from "../helpers/request";

// POST /trial/activate provisions a real Basic 1080p stream on a 24-hour trial
// subscription (no Stripe objects) and returns its id. 400 if trialUsed.
class TrialApi {
  activateTrial() {
    return axiosInstance.post<{ liveStreamId: string }>("/trial/activate");
  }
}

const trialApiInstance = new TrialApi();
export default trialApiInstance;
